import React from 'react';

export const AccountHomeGondola: React.FC = () => null;
